import { Identificable } from 'shared/types/commonView';
import { CommonTranslationKeys } from 'intl/keys';

// ts reports Array.findLastIndex as undefined.
export function findLastIndex<T>(
  predicate: (element: T, index: number, array: T[]) => boolean,
  array: T[]
): number {
  const arrayReversed = [...array].reverse();
  let index = arrayReversed.length - 1;
  for (const element of arrayReversed) {
    const predicateResult = predicate(element, index, arrayReversed);
    if (predicateResult) {
      return index;
    }
    index -= 1;
  }
  return -1;
}

export function filterLanugagesToChoose(values: string[]) {
  return (entity: Identificable) => {
    return !values.includes(entity._id);
  };
}

export function getLanguageSelectDisabledReason({
  isHustroDefault,
  isRemote,
  hasNext,
}: any): string | undefined {
  if (isHustroDefault) {
    return CommonTranslationKeys.disabledCannotChangeHustroDefault;
  }
  if (isRemote) {
    return CommonTranslationKeys.disabledCannotChangeSavedTranslation;
  }
  if (hasNext) {
    return CommonTranslationKeys.disabledCannotChangeLanguageAfterAddNext;
  }
}

export function getLabelChangeDisabledReason({
  isHustroDefault,
}: any): string | undefined {
  if (isHustroDefault) {
    return CommonTranslationKeys.disabledCannotChangeHustroDefault;
  }
}
